import { render, staticRenderFns } from "./CompanyDeleteScreen.vue?vue&type=template&id=b156baf4&scoped=true&lang=pug"
import script from "./CompanyDeleteScreen.vue?vue&type=script&lang=ts"
export * from "./CompanyDeleteScreen.vue?vue&type=script&lang=ts"
import style0 from "./CompanyDeleteScreen.vue?vue&type=style&index=0&id=b156baf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b156baf4",
  null
  
)

export default component.exports